module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/univ-iowa-5572961c8320cc004c46970e2383f30f.svg";